import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import TableFunction from "../../../../components/table/TableFunction";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import {DeleteIconsOptions, DetailsIconsOptions, UpdateIconsOptions} from "../../../../components/buttons/IconButtons";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import routes from "../../../../Routes/routes";
import {TABLES} from "../../../../Apis/Tables";
import {SearchByFilters, SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {CRITERIA_MODEL, SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {ZONE_ACCESS_PERMISSION} from "../Model/Model";
import ZoneAccessExpandedRow from "../ZoneAccess/ZoneAccessExpandedRow";

/**
 * Content of an expanded zone access. The table renders it as a component, so it is declared once:
 * a new function on every render, as opening the options menu causes, would mount the row again
 * and read its zones and guards again.
 */
const renderExpandedRow = ({row}) => <ZoneAccessExpandedRow zoneAccess={row}/>;

/**
 * Zone accesses as an accordion, each one expands the zones and the guards it has.
 */
const ZoneAccessTableApp = ({
    selectedList, setSelectedList, modified, setModified, setDeleteModal,
    searchElement, setBodyForExport, setCriteria, finalArray,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [results, setResults] = useState(null);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const option = TABLES.ZONE_ACCESS;
    const searchId = 'txt_zal_search_zone_access';

    const canUpdate = DEV || permission?.includes(ZONE_ACCESS_PERMISSION.UPDATE);
    const canDelete = DEV || permission?.includes(ZONE_ACCESS_PERMISSION.DELETE);
    const canCreate = DEV || permission?.includes(ZONE_ACCESS_PERMISSION.CREATE);

    const getData = (page, {rowsPerPage}) => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model: option, key: searchElement});
        setBodyForExport(body);
        dispatch(SimpleSearch({body})).then(({payload: {data: {data, success}}}) => {
            if (success) setResults(data);
        });
    };

    // The body is kept as the criteria, the header exports the advanced search with it
    const getDataAdvancedSearch = (page, {rowsPerPage}) => {
        const criteria = finalArray.map((item) => CRITERIA_MODEL.set(item));
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, criteria});
        setCriteria(body);
        dispatch(SearchByFilters({option, body})).then(({payload: {data: {data, success}}}) => {
            if (success) setResults(data);
        });
    };

    const columns = [
        {field: 'name', label: 'name'},
    ];

    const renderOptionsMenu = (item, index) => (
        <DropDownMenuProfile
            openMenu={openMenu}
            handleMenuToggle={handleMenuToggle}
            menuId={`menu-${item.id}`}
        >
            {/* Without the update permission the zone access is opened read-only, as its details */}
            <DropDownMenuItem
                id={`btn_zal_${canUpdate ? 'update' : 'details'}_${index}`}
                index={index}
                handleClose={handleClose}
                name={t(canUpdate ? 'update' : 'details')}
                icon={canUpdate ? <UpdateIconsOptions/> : <DetailsIconsOptions/>}
                click={() => navigate(routes.guards.zoneAccessUpdate + item.id)}
            />
            {canDelete &&
                <DropDownMenuItem
                    id={`btn_zal_delete_${index}`}
                    index={index}
                    handleClose={handleClose}
                    name={t('delete')}
                    icon={<DeleteIconsOptions/>}
                    fontColor={'font-color-error-600'}
                    iconColor={'icon-color-error-code-600'}
                    click={() => {
                        setSelectedList([item.id]);
                        setDeleteModal(true);
                    }}
                />
            }
        </DropDownMenuProfile>
    );

    const {
        t, handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage,
        openMenu, handleMenuToggle, handleClose, handleRowExpand
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        labelRowsPerPage: 'zone_access_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        view: VIEW_TYPE.GRID.name,
        searchElement,
        getData,
        modified,
        setModified,
        getDataAdvancedSearch,
        finalArray,
    });


    return {
        t,
        results,
        setResults,
        simpleSearch,
        setSimpleSearch,
        option,
        searchId,
        isAllChecked,
        columns,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        renderOptionsMenu,
        renderExpandedRow,
        handleRowExpand,
        canUpdate,
        canDelete,
        canCreate,
    };
};

export default ZoneAccessTableApp;
